import { render, staticRenderFns } from "./JobHistoric.html?vue&type=template&id=08be87f0&external"
import script from "./JobHistoric.vue?vue&type=script&lang=js"
export * from "./JobHistoric.vue?vue&type=script&lang=js"
import style0 from "./JobHistoric.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports